// extracted by mini-css-extract-plugin
module.exports = {"OrderItemsFooter":"OrderItemsFooter_OrderItemsFooter__lh0t6","OrderItemsFooter__button":"OrderItemsFooter_OrderItemsFooter__button__gFsY3"};